/** Dictionnaire français (langue source). Clés plates par domaine. */
export const fr = {
  // ── Layout : header ────────────────────────────────────────────────────
  'header.language.fr': 'Français (FR)',
  'header.language.en': 'English (EN)',
  'header.profile': 'Mon profil',
  'header.settings': 'Paramètres du compte',
  'header.adminConsole': "Console d'administration",
  'header.logout': 'Se déconnecter',
  'header.login': 'Se connecter',
  'guest.name': 'Visiteur',

  // ── Layout : sidebar ───────────────────────────────────────────────────
  'nav.landing': 'Accueil',
  'nav.dashboard': 'Tableau de bord',
  'nav.search': 'Recherche & explorer',
  'nav.profile': 'Mon profil & certifications',
  'nav.calls': 'Journal des appels & transcriptions',
  'nav.voiceAgent': 'Agent vocal intelligent',
  'nav.pipeline': 'Pipeline commercial CRM',
  'nav.services': 'Services & tarifs',
  'nav.quota': 'Consommation & quotas',
  'nav.statistics': 'Statistiques & performance',
  'nav.subscription': 'Abonnement & forfait',
  'nav.portfolio': 'Réalisations & galerie',
  'nav.calendar': 'Calendrier & rendez-vous',
  'nav.admin': 'Console administration & conformité',
  'nav.theme.dark': 'Activer le mode sombre',
  'nav.theme.light': 'Activer le mode clair',
  'nav.settings': 'Paramètres généraux',

  // ── Appel vocal (ActiveCallScreen) ─────────────────────────────────────
  'call.connecting': "Connexion à l'assistant…",
  'call.listening': 'À votre écoute…',
  'call.thinking': "L'assistant analyse votre demande…",
  'call.speaking': "L'assistant parle…",
  'call.muteOn': 'Couper le micro',
  'call.muteOff': 'Retirer le muet',
  'call.mute': 'Muet',
  'call.unmute': 'Activer micro',
  'call.transcript': 'Transcription',
  'call.transcriptTitle': 'Transcription de la conversation',
  'call.you': 'Vous',
  'call.hangup': 'Raccrocher',
  'call.close': 'Fermer',
  'call.sessionRequired': 'Session requise : connectez-vous pour appeler cet assistant.',
  'call.emptyTranscript': "Parlez — la transcription s'affiche en temps réel.",

  // ── Paramètres (/pro/settings, /app/settings) ──────────────────────────
  'settings.title': 'Paramètres',
  'settings.subtitle': 'Préférences de votre compte, applicables à toutes vos pages.',
  'settings.appearance': 'Apparence',
  'settings.darkMode': 'Mode sombre',
  'settings.darkModeHint': "Bascule l'interface entière en thème sombre.",
  'settings.language': "Langue de l'interface",
  'settings.languageHint': 'Immédiatement appliqué sur toutes les pages et composants.',
  'settings.notifications': 'Notifications',
  'settings.notificationsHint': 'Alertes e-mail pour appels, devis et rendez-vous.',
  'settings.account': 'Compte',
  'settings.signedInAs': 'Connecté en tant que',
  'settings.role': 'Rôle',
  'settings.logout': 'Se déconnecter',
  'settings.saved': 'Préférences enregistrées.',

  // ── Rôles de session ─────────────────────────────────────────────────
  'role.client': 'Client',
  'role.professional_owner': 'Professionnel',
  'role.professional_agent': 'Agent professionnel',
  'role.moderator': 'Modérateur',
  'role.admin': 'Administrateur',
} as const;

export type TranslationKey = keyof typeof fr;
